export const DRAWER_WIDTH = 240
export const HEADER_HEIGHT = 75
export const FOOTER_CONTENT_HEIGHT = 88
export const HEADER_HEIGHT_MOBILE = 60
